import {
  styled,
  TableRow as MuiTableRow,
  TableRowProps as MuiTableRowProps,
  tableRowClasses,
} from '@mui/material';

import { RowType } from '../../cells/cells.type';

interface TableRowProps extends MuiTableRowProps {
  type?: RowType;
  expanded?: 'true' | 'false';
  child?: 'true' | 'false';
}

export const TableRow = styled(
  ({ ...props }: TableRowProps) => <MuiTableRow {...props} />,
  {
    shouldForwardProp: prop => !['type'].includes(prop as any),
  }
)(({ type = 'default', expanded = 'false', child = 'false', theme }) => ({
  [`&.${tableRowClasses.root}`]: {
    backgroundColor:
      type === 'success'
        ? theme.palette.success.contrastText
        : expanded === 'true' || child === 'true'
        ? type === 'error'
          ? `${theme.palette.error.main}1f`
          : type === 'warning'
          ? `${theme.palette.warning.main}1f`
          : 'unset'
        : 'unset',

    fontWeight: type === 'success' ? 700 : 400,

    '&:hover': {
      boxShadow: 'none',
      backgroundColor:
        type === 'success'
          ? theme.palette.success.contrastText
          : type === 'error'
          ? `${theme.palette.error.main}1f`
          : type === 'warning'
          ? `${theme.palette.warning.main}1f`
          : 'unset',
    },
  },
}));
